import React, { FC } from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'
import Box from '@material-ui/core/Box'

interface SwitchArrowProps {
  activeColor?: boolean
  order?: string
}

export const SwitchArrow: FC<SwitchArrowProps> = ({ activeColor, order }, props) => {
  return (
    <Box
      alignItems='center'
      display='flex'
      flexDirection='column'
    >
      <SvgIcon
        {...props}
        fontSize='small'
        htmlColor={activeColor && order === 'asc' ? '#1D93F3' : '#8D9091'}
        viewBox='0 0 24 10'
      >
        <path d='M7 14l5-5 5 5H7z' />
      </SvgIcon>
      <SvgIcon
        {...props}
        fontSize='small'
        htmlColor={activeColor && order === 'desc' ? '#1D93F3' : '#8D9091'}
        viewBox='0 10 24 24'
      >
        <path d='M7 10l5 5 5-5H7z' />
      </SvgIcon>
    </Box>
  )
}
